var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotCollaborate2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 77,
    viewBox: "0 0 96 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2191 62.3368C42.2795 62.3368 43.1391 63.1964 43.1391 64.2566V74.3366V74.8166C43.1391 75.8771 42.2795 76.7366 41.2191 76.7366H40.7391H40.2591H35.9391C34.6136 76.7366 33.5391 75.662 33.5391 74.3366C33.5391 73.0112 34.6136 71.9366 35.9391 71.9366H37.3791C37.9092 71.9366 38.3391 71.5072 38.3391 70.9766V64.2566C38.3391 63.1964 39.1986 62.3368 40.2591 62.3368H41.2191Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8497 62.3368C53.7893 62.3368 52.9297 63.1964 52.9297 64.2566V74.3366V74.8166C52.9297 75.8771 53.7893 76.7366 54.8497 76.7366H55.3297H55.8097H60.1297C61.4552 76.7366 62.5297 75.662 62.5297 74.3366C62.5297 73.0112 61.4552 71.9366 60.1297 71.9366H58.6897C58.1595 71.9366 57.7297 71.5072 57.7297 70.9766V64.2566C57.7297 63.1964 56.8701 62.3368 55.8097 62.3368H54.8497Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7994 13.796C84.7987 13.796 84.7987 13.7957 84.7987 13.7953C84.7994 13.7528 84.8 13.7102 84.8 13.6675V5.77236C84.8 1.81658 80.9043 -0.961951 77.1642 0.326419L49.9276 9.70874C48.7137 10.1269 47.3948 10.1275 46.1805 9.7104L18.831 0.31697C15.0919 -0.967289 11.2 1.81103 11.2 5.76461V13.796V17.8289V44.992C11.2 46.5826 9.91059 47.872 8.32 47.872H4.864C2.17769 47.872 0 50.0497 0 52.736C0 55.4223 2.17769 57.6 4.864 57.6H91.136C93.8221 57.6 96 55.4223 96 52.736C96 50.0497 93.8221 47.872 91.136 47.872H87.68C86.0896 47.872 84.8 46.5826 84.8 44.992V13.7967C84.8 13.7964 84.8 13.796 84.7994 13.796Z",
    fill: "#FFBC57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2003 38.336H84.8003V44.992C84.8003 46.5826 86.0899 47.872 87.6803 47.872H8.32031C9.9109 47.872 11.2003 46.5826 11.2003 44.992V38.336Z",
    fill: "#5775FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6107_2990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 19,
    width: 20,
    height: 29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0008 28.736C48.0008 23.4341 43.7027 19.136 38.4008 19.136C33.0988 19.136 28.8008 23.4341 28.8008 28.736V38.336C28.8008 43.6379 33.0988 47.936 38.4008 47.936C43.7027 47.936 48.0008 43.6379 48.0008 38.336V28.736Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6107_2990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0008 28.736C48.0008 23.4341 43.7027 19.136 38.4008 19.136C33.0988 19.136 28.8008 23.4341 28.8008 28.736V38.336C28.8008 43.6379 33.0988 47.936 38.4008 47.936C43.7027 47.936 48.0008 43.6379 48.0008 38.336V28.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8131 32.7545C28.6755 33.2013 28.6016 33.676 28.6016 34.1679V38.9679C28.6016 41.6189 30.7506 43.7679 33.4016 43.7679C36.0525 43.7679 38.2016 41.6189 38.2016 38.9679V34.1679C38.2016 31.517 36.0525 29.3679 33.4016 29.3679C32.9096 29.3679 32.435 29.4419 31.9881 29.5794C32.8215 29.9557 33.4016 30.7941 33.4016 31.7679C33.4016 33.0934 32.3271 34.1679 31.0016 34.1679C30.0277 34.1679 29.1893 33.5879 28.8131 32.7545Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6107_2990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 19,
    width: 20,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 28.736C67.2 23.4341 62.9019 19.136 57.6 19.136C52.2981 19.136 48 23.4341 48 28.736V38.336C48 43.6379 52.2981 47.936 57.6 47.936C62.9019 47.936 67.2 43.6379 67.2 38.336V28.736Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6107_2990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2 28.736C67.2 23.4341 62.9019 19.136 57.6 19.136C52.2981 19.136 48 23.4341 48 28.736V38.336C48 43.6379 52.2981 47.936 57.6 47.936C62.9019 47.936 67.2 43.6379 67.2 38.336V28.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.975 32.8179C47.8615 33.2272 47.8008 33.6585 47.8008 34.104V38.9378C47.8008 41.5888 49.9498 43.7378 52.6008 43.7378C55.2517 43.7378 57.4008 41.5888 57.4008 38.9378V34.104C57.4008 31.453 55.2517 29.304 52.6008 29.304C52.1409 29.304 51.696 29.3687 51.275 29.4894C52.0611 29.8835 52.6008 30.6969 52.6008 31.6362V31.9185C52.6008 33.2441 51.5263 34.3185 50.2008 34.3185C49.1934 34.3185 48.3309 33.6978 47.975 32.8179Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotCollaborate2Fill);
export default __webpack_public_path__ + "static/media/mascot-collaborate-2-fill.ed5821c57bf9dc212442ce4faad27dd9.svg";
export { ForwardRef as ReactComponent };